import type { Router, RouteLocationRaw } from "vue-router";
import { isNothing, nothing, type Maybe } from "./maybe";

/** Bound from `EditorShell` so Pinia stores can push without `useRouter()`. */
let projectRouter: Maybe<Router> = nothing;

export function bindProjectRouter(router: Router): void {
  projectRouter = { tag: "just", value: router };
}

export function getProjectRouter(): Maybe<Router> {
  return projectRouter;
}

/**
 * Extra query to stitch onto in-app navigations. Project identity now lives in
 * the host path (`/editor/<uuid>/`), so this stays empty for the hosted editor.
 */
export function projectQuery(): Record<string, string> {
  return {};
}

export async function pushProjectPath(path: string): Promise<void> {
  if (isNothing(projectRouter)) return;
  const router = projectRouter.value;
  const query = projectQuery();
  const current = router.currentRoute.value;
  if (
    current.path === path &&
    JSON.stringify(current.query) === JSON.stringify(query)
  ) {
    return;
  }
  const location: RouteLocationRaw =
    Object.keys(query).length > 0 ? { path, query } : path;
  await router.push(location);
}
